// acciones
export const SAGA_GET_SUPERRUBROS_COMBO = 'rubrosReducer/SAGA_GET_SUPERRUBROS_COMBO'
export const SET_SUPERRUBROS_COMBO = 'rubrosReducer/SET_SUPERRUBROS_COMBO'

export const SAGA_GET_RUBROS = 'rubrosReducer/SAGA_GET_RUBROS'
export const SET_RUBROS = 'rubrosReducer/SET_RUBROS'
export const SWAP_RUBROS = 'rubrosReducer/SWAP_RUBROS'
export const SAGA_GET_RUBRO_ID = 'rubrosReducer/SAGA_GET_RUBRO_ID'
export const SAVE_RUBRO= 'rubrosReducer/SAVE_RUBRO'
export const ELIMINAR_RUBRO= 'rubrosReducer/ELIMINAR_RUBRO'
export const REVERTIR_RUBRO= 'rubrosReducer/REVERTIR_RUBRO'
export const SAGA_SAVE_RUBRO = 'rubrosReducer/SAGA_SAVE_RUBRO'
export const SAGA_SAVE_IMAGEN_RUBRO = 'rubrosReducer/SAGA_SAVE_IMAGEN_RUBRO'

export const SAGA_GET_SUBRUBROS = 'rubrosReducer/SAGA_GET_SUBRUBROS'
export const SAVE_SUBRUBRO= 'rubrosReducer/SAVE_SUBRUBRO'
export const ELIMINAR_SUBRUBRO= 'rubrosReducer/ELIMINAR_SUBRUBRO'
export const REVERTIR_SUBRUBRO= 'rubrosReducer/REVERTIR_SUBRUBRO'
export const SET_SUBRUBROS = 'rubrosReducer/SET_SUBRUBROS'
export const SWAP_SUBRUBROS = 'rubrosReducer/SWAP_SUBRUBROS'
export const SAGA_SAVE_SUBRUBRO = 'rubrosReducer/SAGA_SAVE_SUBRUBRO'
export const SAGA_GET_SUBRUBRO_ID = 'rubrosReducer/SAGA_GET_SUBRUBRO_ID'

export const SAGA_GET_SUBRUBROS_PICKING = 'rubrosReducer/SAGA_GET_SUBRUBROS_PICKING'
export const SAVE_SUBRUBROS_PICKING = 'rubrosReducer/SAVE_SUBRUBROS_PICKING'
export const SWAP_SUBRUBROS_PICKING = 'rubrosReducer/SWAP_SUBRUBROS_PICKING'

// funciones
export const sagaGetSubRubrosPicking = () =>({
    type: SAGA_GET_SUBRUBROS_PICKING
})

export const saveSubRubrosPicking = (payload) =>({
    type: SAVE_SUBRUBROS_PICKING,
    payload
})

export const sagaGetSuperRubros = () =>({
    type: SAGA_GET_SUPERRUBROS_COMBO
})

export const setSuperRubros = (payload) =>({
    type: SET_SUPERRUBROS_COMBO,
    payload
})

export const sagaGetRubros = (nombre, activos, comboBox) =>({
    type: SAGA_GET_RUBROS,
    query: nombre,
    activos: activos!==undefined?activos:true,
    comboBox: comboBox
})

export const setRubros = (payload) =>({
    type: SET_RUBROS,
    payload
})
export const saveRubro = (payload) =>({
    type: SAVE_RUBRO,
    payload
})
export const saveSubRubro = (payload) =>({
    type: SAVE_SUBRUBRO,
    payload
})
export const sagaGetRubroId = (id) =>({
    type: SAGA_GET_RUBRO_ID,
    payload: {id}
})
export const sagaGetSubRubroId = (id) =>({
    type: SAGA_GET_SUBRUBRO_ID,
    payload: {id}
})
export const sagaSaveRubro = (payload) =>({
    type: SAGA_SAVE_RUBRO,
    payload
})
export const sagaSaveSubRubro = (payload) =>({
    type: SAGA_SAVE_SUBRUBRO,
    payload
})
export const sagaSaveImagenRubro = (payload) =>({
    type: SAGA_SAVE_IMAGEN_RUBRO,
    payload
})

export const sagaGetSubRubros = (idRubro, query, comboBox) =>({
    type: SAGA_GET_SUBRUBROS,
    payload: idRubro,
    query: query,
    comboBox: comboBox
    
})

export const setSubRubros = (payload) =>({
    type: SET_SUBRUBROS,
    payload
})

export const swapRubros = (from, to) => ({
    type: SWAP_RUBROS,
    from, 
    to
})

export const swapSubRubrosPicking = (from, to) => ({
    type: SWAP_SUBRUBROS_PICKING,
    from, 
    to
})

export const swapSubRubros = (from, to, idRubro, query, comboBox) => ({
    type: SWAP_SUBRUBROS,
    from, 
    to,

    payload: idRubro,
    query: query,
    comboBox: comboBox
})


export const sagaEliminiarRubro = (id) =>({
    type: ELIMINAR_RUBRO ,
    payload: {id}
})
export const sagaRevertirRubro = (id) =>({
    type: REVERTIR_RUBRO,
    payload: {id}
})
export const sagaEliminiarSubrubro = (id) =>({
    type: ELIMINAR_SUBRUBRO,
    payload: {id}
})
export const sagaRevertirSubrubro = (id) =>({
    type: REVERTIR_SUBRUBRO,
    payload: {id}
})